import React from "react";
import Image from "components/AppImage";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function FeaturedGameCard({ game, onPlay, onLike }) {
  return (
    <div
      className="group flex flex-col rounded-2xl overflow-hidden border transition-all duration-300 hover:-translate-y-1"
      style={{
        background: "var(--color-card)",
        borderColor: "var(--color-border)",
        boxShadow: "var(--shadow-sm)",
      }}
    >
      <div className="relative w-full h-40 md:h-44 overflow-hidden">
        <Image
          src={game?.thumbnail}
          alt={game?.thumbnailAlt}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <span
          className="absolute top-2 left-2 text-xs font-semibold px-2 py-0.5 rounded-full"
          style={{ background: "var(--color-primary)", color: "white" }}
        >
          {game?.mode}
        </span>
        <button
          onClick={() => onPlay(game)}
          className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          aria-label={`Play ${game?.title}`}
        >
          <div
            className="flex items-center justify-center w-14 h-14 rounded-full"
            style={{ background: "rgba(255,255,255,0.9)" }}
          >
            <Icon name="Play" size={24} color="var(--color-primary)" />
          </div>
        </button>
      </div>
      <div className="flex flex-col p-3 md:p-4 gap-1 flex-1">
        <h4
          className="font-heading font-semibold text-sm md:text-base line-clamp-1"
          style={{ color: "var(--color-foreground)" }}
        >
          {game?.title}
        </h4>
        <p
          className="text-xs line-clamp-2 flex-1"
          style={{ color: "var(--color-muted-foreground)" }}
        >
          {game?.prompt}
        </p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-3">
            <button
              onClick={() => onLike && onLike(game?.id)}
              className="flex items-center gap-1 text-xs transition-all hover:scale-110 active:scale-95"
              style={{ color: game?.liked ? '#ef4444' : 'var(--color-muted-foreground)' }}
              aria-label={game?.liked ? 'Unlike' : 'Like'}
            >
              <Icon
                name={game?.liked ? 'Heart' : 'Heart'}
                size={13}
                color={game?.liked ? '#ef4444' : 'var(--color-muted-foreground)'}
                fill={game?.liked ? '#ef4444' : 'none'}
              />
              <span style={{ fontFamily: 'var(--font-data)' }}>{game?.likes?.toLocaleString()}</span>
            </button>
            <span className="flex items-center gap-1 text-xs" style={{ color: "var(--color-muted-foreground)" }}>
              <Icon name="Play" size={12} />
              <span style={{ fontFamily: 'var(--font-data)' }}>{game?.plays?.toLocaleString()}</span>
            </span>
          </div>
          <Button variant="outline" size="xs" iconName="Play" iconPosition="left" onClick={() => onPlay(game)}>
            Play
          </Button>
        </div>
      </div>
    </div>
  );
}